import React, { useEffect } from "react";
import { Autocomplete, Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Grid, Paper, styled, TextField } from "@mui/material";
import axios from "axios";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { IFeeding } from "../../interfaces/Growing/IFeeding";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import ConfirmDialog, { confirmDialog } from "../ConfirmDialog";
import { ICrew } from "../../interfaces/ICrew";

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#010101' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    border: 0,
    borderRadius: 0,
    boxShadow: "none",
}));


type Props = {
    open: boolean,
    handleClose: () => void
}

export default function FeedingDialog(props: Props) {

    const { register, handleSubmit, control, formState: { errors } } = useForm<IFeeding>();

    const [open, setOpen] = React.useState(false);
    const [crews, setCrews] = React.useState<ICrew[]>([]);
    const [acids, setAcids] = React.useState<IAcid[]>([]);
    const [fertilizers, setFertilizers] = React.useState<IFertilizer[]>([]);
    const [chemicals, setChemicals] = React.useState<IChemical[]>([]);

    interface IAcid {
        id: number,
        name: string
    }

    interface IFertilizer {
        id: number,
        name: string
    }

    interface IChemical {
        id: number,
        name: string
    }



    const onSubmit: SubmitHandler<IFeeding> = data => {
        console.log(data);
        axios.get(`${process.env.REACT_APP_ENDPOINT}/api/Feedings`).then(data => {
            console.log(data);
        });
        let massagedData: IFeeding = {
            id: data.id != undefined ? 0 : 0,
            feedingId: 0,
            crewId: data.crew != undefined ? data.crew.id : 0,
            pipe: data.pipe,
            fertilizer: data.fertilizer,
            chemical: data.chemical,
            acid: data.acid,
            waterNozzleSize: data.waterNozzleSize,
            percentFertilizer: data.percentFertilizer,
            percentChemical: data.percentChemical,
            percentAcid: data.percentAcid,
            createdAt: new Date(),
            updatedAt: new Date(),
            notes: data.notes
        }
        console.log("MASSAGED DATA", massagedData);
        axios.post(`${process.env.REACT_APP_ENDPOINT}/api/Feedings`, massagedData).then((data) => {
            if (data.status === 200) {
                setOpen(false);
            };
        });
    };

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_ENDPOINT}/api/Crews`)
            .then(res => {
                setCrews(res.data);
            })

        var exampleAcid: IAcid = {
            id: 1,
            name: "Acid 1"
        }

        setAcids([{ id: 1, name: "Acid 1" }, { id: 2, name: "Acid 2" }, { id: 3, name: "Acid 3" }]);
        setFertilizers([{ id: 1, name: "Fertilizer 1" }, { id: 2, name: "Fertilizer 2" }, { id: 3, name: "Fertilizer 3" }]);
        setChemicals([{ id: 1, name: "Chemical 1" }, { id: 2, name: "Chemical 2" }, { id: 3, name: "Chemical 3" }]);
    }, [])

    const pipes = [
        { id: 1, label: 'Red Pipe' },
        { id: 2, label: 'Blue Pipe' },
        { id: 3, label: 'Plain Pipe' },
    ];



    return (
        <Dialog open={props.open} onClose={props.handleClose} maxWidth='xl' fullWidth>
            <DialogTitle>Assign Feeding</DialogTitle>
            <Box component="form">
                <TextField
                    sx={{ display: "none" }}
                    {...register('id')}
                    required
                    variant="filled"
                    fullWidth
                    id="id"
                    label="ID" />
                <DialogContent>
                    <Grid container spacing={0} >
                        <Grid item xs={12}>
                            <Item>
                                <Controller
                                    control={control}
                                    name="pipe"
                                    render={({ field: { ref, onChange, ...field } }) => (
                                        <Autocomplete
                                            isOptionEqualToValue={(option, value) => option.label == value.label}
                                            options={pipes}
                                            getOptionLabel={(option) => option.label}
                                            onChange={(_, data) => {
                                                return onChange(data?.label);
                                            }}
                                            renderInput={(params) => (
                                                <TextField {...params} {...field} fullWidth inputRef={ref} variant="filled" label="Please select the intended Pipe"></TextField>
                                            )}
                                        />
                                    )}
                                />
                            </Item>
                        </Grid>

                        <Grid item xs={4}>
                            <Item>
                                <Controller
                                    control={control}
                                    name="fertilizer"
                                    render={({ field: { ref, onChange, ...field } }) => (
                                        <Autocomplete
                                            options={fertilizers}
                                            getOptionLabel={(option) => option.name}
                                            onChange={(_, data) => {
                                                return onChange(data?.name);
                                            }}
                                            renderInput={(params) => (
                                                <TextField {...params} {...field} fullWidth inputRef={ref} variant="filled" label="Fertilizer"></TextField>
                                            )}
                                        />
                                    )}
                                />
                            </Item>
                        </Grid>
                        <Grid item xs={4}>
                            <Item>
                                <Controller
                                    control={control}
                                    name="chemical"
                                    // defaultValue={ patchingListTypes[0].label }
                                    render={({ field: { ref, onChange, ...field } }) => (
                                        <Autocomplete
                                            options={chemicals}
                                            getOptionLabel={(option) => option.name}
                                            onChange={(_, data) => {
                                                return onChange(data?.name);
                                            }}
                                            // defaultValue={[patchingListTypes[0]]}
                                            renderInput={(params) => (
                                                <TextField {...params} {...field} fullWidth inputRef={ref} variant="filled" label="Chemical"></TextField>
                                            )}
                                        />
                                    )}
                                />
                            </Item>
                        </Grid>
                        <Grid item xs={4}>
                            <Item>
                                <Controller
                                    control={control}
                                    name="acid"
                                    // defaultValue={ patchingListTypes[0].label }
                                    render={({ field: { ref, onChange, ...field } }) => (
                                        <Autocomplete
                                            options={acids}
                                            getOptionLabel={(option) => option.name}
                                            onChange={(_, data) => {
                                                return onChange(data?.name);
                                            }}
                                            // defaultValue={[patchingListTypes[0]]}
                                            renderInput={(params) => (
                                                <TextField {...params} {...field} fullWidth inputRef={ref} variant="filled" label="Acid"></TextField>
                                            )}
                                        />
                                    )}
                                />
                            </Item>
                        </Grid>
                        <Grid item xs={4}>
                            <Item>
                                <TextField
                                    required
                                    variant="filled"
                                    fullWidth
                                    id="fertilizerpercent"
                                    label="Fertilizer Percent"
                                    {...register('percentFertilizer')} />
                            </Item>
                        </Grid>
                        <Grid item xs={4}>
                            <Item>
                                <TextField
                                    {...register('percentChemical')}
                                    required
                                    variant="filled"
                                    fullWidth
                                    id="patchinglistname"
                                    label="Chemical Percent"
                                />
                            </Item>
                        </Grid>
                        <Grid item xs={4}>
                            <Item>
                                <TextField
                                    {...register('percentAcid')}
                                    required
                                    variant="filled"
                                    fullWidth
                                    id="acidPercent"
                                    label="Acid Percent"
                                />
                            </Item>

                        </Grid>
                        <Grid item xs={6}>
                            <Item>
                                <TextField
                                    {...register('waterNozzleSize')}
                                    required
                                    variant="filled"
                                    fullWidth
                                    id="waternozzlesize"
                                    label="Water Nozzle Size" />
                            </Item>
                        </Grid>
                        <Grid item xs={6}>
                            <Item>
                                <Controller
                                    control={control}
                                    name="crew"
                                    // defaultValue={ patchingListTypes[0].label }
                                    render={({ field: { ref, onChange, ...field } }) => (
                                        <Autocomplete
                                            options={crews}
                                            getOptionLabel={(option) => `${option.id}-${option.name}`}
                                            onChange={(_, data) => {
                                                return onChange(data);
                                            }}
                                            // defaultValue={[patchingListTypes[0]]}
                                            renderInput={(params) => (
                                                <TextField {...params} {...field} fullWidth inputRef={ref} variant="filled" label="Crew"></TextField>
                                            )}
                                        />
                                    )}
                                />
                            </Item>
                        </Grid>
                        <Grid item xs={12}>
                            <Item>
                                <TextField
                                    required
                                    variant="filled"
                                    fullWidth
                                    id="feedingnotes"
                                    label="Feeding Notes"
                                    {...register('notes')} />
                            </Item>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button size="large" variant="outlined" onClick={props.handleClose}>Cancel</Button>
                    <Button size="large" variant="contained" color="success" onClick={() => confirmDialog("Are you sure you want to add this feeding?", handleSubmit(onSubmit))}>Add Feeding</Button>
                </DialogActions>
                <ConfirmDialog />
            </Box>
        </Dialog>
    )
}